module.exports = __webpack_public_path__ + "media/Images/advisor-home-hero-ecfdc03e808467785f7e8724c632f2e2.jpg";